import { createContext, useContext } from 'react';

export interface AuthStateValue {
  isAuthenticated: boolean;
  isLoading: boolean;
  signinRedirect: () => void;
  signoutRedirect: () => void;
}

export const AuthStateContext = createContext<AuthStateValue | null>(null);

export function useAuthState(): AuthStateValue {
  const ctx = useContext(AuthStateContext);
  if (!ctx) throw new Error('useAuthState must be used within <AuthProvider>');
  return ctx;
}
